import React, { Component } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { _axios } from '../../plugins/axios';
import { URL, USER } from "../../constants/constant";
import TitleOrderHeader from "../common/titleOrderHeader";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ToasterComponent from "../common/toaster";

class AddVitals extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userdetails: USER.user,
            orderId: parseInt(this.props.match.params.orderId),
            orderDetails: USER.orderDetails,
            submitBtnDisabled: false,
            messageSnacks: "",
            showSnackbar: false,
            memberForms: [
                {
                    orderId: parseInt(this.props.match.params.orderId),
                    id_proof_type: "",
                    id_proof_value: "",
                    id_proof_other_type: "",
                    name_as_per_govt_id: "",
                    height: "",
                    weight: "",
                    abdomen_girth_naval: "",
                    chest_inhale: "",
                    chest_exhale: "",
                    respiratory_rate: "",
                    hip_size: "",
                    waist_size: "",
                    bp_reading: [
                        {
                            systolic: "",
                            diastolic: "",
                            pulse: ""
                        }, {
                            systolic: "",
                            diastolic: "",
                            pulse: ""
                        }, {
                            systolic: "",
                            diastolic: "",
                            pulse: ""
                        }],
                    is_there_weight_change: "",
                    weight_change_type: "",
                    weight_change_value: "",
                    reason_for_change: ""
                }
            ],
            labtests: []
        }
    }

    redirectToBookLater() {
        this.setState({
            memberForms: [
                {
                    id_proof_type: "",
                    id_proof_other_type: "",
                    id_proof_value: "",
                    name_as_per_govt_id: "",
                    height: "",
                    weight: "",
                    abdomen_girth_naval: "",
                    chest_inhale: "",
                    chest_exhale: "",
                    respiratory_rate: "",
                    hip_size: "",
                    waist_size: "",
                    bp_reading: [
                        {
                            systolic: "",
                            diastolic: "",
                            pulse: ""
                        }, {
                            systolic: "",
                            diastolic: "",
                            pulse: ""
                        }, {
                            systolic: "",
                            diastolic: "",
                            pulse: ""
                        }],
                    is_there_weight_change: "",
                    weight_change_type: "",
                    weight_change_value: "",
                    reason_for_change: ""
                }
            ]
        })
    }

    goBackRoute() {
        this.props.history.goBack()
    }


    toastComponent() {
        return <ToasterComponent show={this.state.showSnackbar ? this.state.showSnackbar : ''} message={this.state.messageSnacks ? this.state.messageSnacks : ''}></ToasterComponent>;
    }

    handleSubmit(event) {
        const that = this;
        event.preventDefault();
        console.log(this.state.memberForms);
        let url = URL.REACT_FUSER_URL;
        let route = url + 'api/v1/digitization/runnr/vitals/save'
        let payload = this.state.memberForms[0];
        _axios.post(route, payload)
            .then(function (response) {
                if (response.data.success) {
                    that.setState({
                        messageSnacks: response.data.message,
                        showSnackbar: true,
                    }, () => {
                        that.toastComponent();
                        setTimeout(() => {
                            that.goBackRoute();
                        },1000)
                    })
                    
                } else {
                    that.setState({
                        messageSnacks: response.data.message,
                        showSnackbar: true,
                    }, () => {
                        that.toastComponent();
                        setTimeout(() => {
                            that.goBackRoute();
                        },1000)
                        
                    })
                }
            }).catch(function (error) {
                console.log(error);
                that.setState({
                    messageSnacks: error.message,
                    showSnackbar: true,
                }, () => {
                    that.toastComponent();
                    setTimeout(() => {
                        that.goBackRoute();
                    },1000)
                    
                })
            })
    }

    handleChange(elem, index, event) {
        const { name, value, type } = event.target;
        var membersTemp = this.state.memberForms;

        if (value && type == "number") {
            var regexp = /^(\d{1,5}|\d{0,5}\.\d{1,2})$/;
            if (regexp.test(parseFloat(value))) {
                if (["systolic 0", "diastolic 0", "pulse 0", "systolic 1", "diastolic 1", "pulse 1", "systolic 2", "diastolic 2", "pulse 2"].includes(name)) {
                    let nameArray = name.split(' ');
                    membersTemp[index]['bp_reading'][nameArray[1]][nameArray[0]] = parseFloat(value);
                }
                else {
                    membersTemp[index][name] = parseFloat(value);
                }
            }
        } else {
            if (["systolic 0", "diastolic 0", "pulse 0", "systolic 1", "diastolic 1", "pulse 1", "systolic 2", "diastolic 2", "pulse 2"].includes(name)) {
                let nameArray = name.split(' ');
                membersTemp[index]['bp_reading'][nameArray[1]][nameArray[0]] = parseFloat(value);
            }else{
                membersTemp[index][name] = value;
            }
        }

        if (membersTemp[index]["id_proof_type"] != "Others") {
            membersTemp[index]["id_proof_other_type"] = "";
        }

        if (membersTemp[index]["is_there_weight_change"] == "false") {
            membersTemp[index]["weight_change_type"] = ""
            membersTemp[index]["weight_change_value"] = ""
            membersTemp[index]["reason_for_change"] = ""
        }

        this.setState({
            memberForms: membersTemp,
        }, () => {
            this.checkFormValidation()
        })
    }

    checkFormValidation() {
        let disableBtn = true;
        var payload = this.state.memberForms[0];

        let is_there_weight_change = payload["is_there_weight_change"];
        let id_proof_type = payload["id_proof_type"];

        if (is_there_weight_change == "true" && id_proof_type == "Others") {
            for (const obj in payload) {
                if (payload[obj] == "") {
                    disableBtn = false;
                }
            }
        } else if (is_there_weight_change != "true" && id_proof_type != "Others") {
            for (const obj in payload) {
                if (!["weight_change_type", "weight_change_value", "reason_for_change", "id_proof_other_type"].includes(obj) && payload[obj] == "")
                    disableBtn = false;
            }
        }
        else if (is_there_weight_change != "true" && id_proof_type == "Others") {
            for (const obj in payload) {
                if (!["weight_change_type", "weight_change_value", "reason_for_change"].includes(obj) && payload[obj] == "")
                    disableBtn = false;
            }
        } else if (is_there_weight_change == "true" && id_proof_type != "Others") {
            for (const obj in payload) {
                if (!["id_proof_other_type"].includes(obj) && payload[obj] == "")
                    disableBtn = false;
            }
        }

        this.setState({
            submitBtnDisabled: disableBtn
        })
    }

    showForm() {
        return (<div>
            {
                this.state.memberForms ? this.state.memberForms.map((elem, index) => (
                    <Form key={index} onSubmit={(e) => this.handleSubmit(e)} className="p-t-20 p-b-20">
                        <Row className="p-t-4">
                            <Col xs={6} md={6}>
                                {/* <Form.Control type="text" name='gender'  placeholder="Gender"  value={elem.gender || ''} onChange={(e)=>this.handleChange(elem,index,e)}/> */}
                                <span className="font-size-xsm">Select Id Proof <span className="red-color">*</span></span>
                                <Form.Control as="select" name="id_proof_type" value={elem.id_proof_type || ''} onChange={(e) => this.handleChange(elem, index, e)}>
                                    <option value="">Select Id Proof</option>
                                    <option value="Aadhaar Card">Aadhaar Card</option>
                                    <option value="PAN Card">PAN Card</option>
                                    <option value="Voter Id">Voter Id</option>
                                    <option value="Passport">Passport</option>
                                    <option value="Driving license">Driving license</option>
                                    <option value="Others">Others</option>
                                </Form.Control>
                            </Col>

                            {
                                elem.id_proof_type == "Others" &&
                                <Col xs={6} md={6}>
                                    <span className="font-size-xsm">Id Proof <span className="red-color">*</span></span>
                                    <Form.Control type="text" name='id_proof_other_type' placeholder="ID proof" value={elem.id_proof_other_type || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                                </Col>
                            }

                            {
                                elem.id_proof_type != "Others" &&
                                <Col xs={6} md={6}>
                                    <span className="font-size-xsm">Id Number <span className="red-color">*</span></span>
                                    <Form.Control type="text" name='id_proof_value' placeholder="ID Number" value={elem.id_proof_value || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                                </Col>
                            }


                        </Row>
                        {
                            elem.id_proof_type == "Others" &&
                            <Row>
                                <Col xs={12} md={12}>
                                    <span className="font-size-xsm">Id Number <span className="red-color">*</span></span>
                                    <Form.Control type="text" name='id_proof_value' placeholder="ID Number" value={elem.id_proof_value || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                                </Col>
                            </Row>
                        }



                        <Row className="p-t-4">
                            <Col xs={12} md={12}>
                                <span className="font-size-xsm">Name (as per Govt ID) <span className="red-color">*</span></span>
                                <Form.Control type="text" name='name_as_per_govt_id' placeholder="Name" value={elem.name_as_per_govt_id || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                            </Col>
                        </Row>
                        <Row className="p-t-4">
                            <Col xs={6} md={6}>
                                <span className="font-size-xsm">Height (in Cms) <span className="red-color">*</span></span>
                                <Form.Control type="number" name='height' placeholder="Height" value={elem.height || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                            </Col>
                            <Col xs={6} md={6}>
                                <span className="font-size-xsm">Weight (in Kgs) <span className="red-color">*</span></span>
                                <Form.Control type="number" name='weight' placeholder="Weight" value={elem.weight || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                            </Col>
                        </Row>

                        <Row className="p-t-4">
                            <Col xs={6} md={6}>
                                <span className="font-size-xsm">Abdomen Girth at naval (in Cms) <span className="red-color">*</span></span>
                                <Form.Control type="number" name='abdomen_girth_naval' placeholder="Abdomen Girth" value={elem.abdomen_girth_naval || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                            </Col>
                            <Col xs={6} md={6}>
                                <span className="font-size-xsm">Respiratory Rate (per minute) <span className="red-color">*</span></span>
                                <Form.Control type="number" name='respiratory_rate' placeholder="Respiratory Rate" value={elem.respiratory_rate || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                            </Col>
                        </Row>
                        <Row className="p-t-4">
                            <Col xs={6} md={6}>
                                <span className="font-size-xsm">Chest Inhale (in Cms) <span className="red-color">*</span></span>
                                <Form.Control type="number" name='chest_inhale' placeholder="Chest Inhale" value={elem.chest_inhale || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                            </Col>
                            <Col xs={6} md={6}>
                                <span className="font-size-xsm">Chest Exhale (in Cms) <span className="red-color">*</span></span>
                                <Form.Control type="number" name='chest_exhale' placeholder="Chest Exhale" value={elem.chest_exhale || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                            </Col>
                        </Row>
                        <Row className="p-t-4">
                            <Col xs={6} md={6}>
                                <span className="font-size-xsm">Hip size (in Cms)  <span className="red-color">*</span></span>
                                <Form.Control type="number" name='hip_size' placeholder="Hip size" value={elem.hip_size || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                            </Col>
                            <Col xs={6} md={6}>
                                <span className="font-size-xsm">Waist size (in Cms)  <span className="red-color">*</span></span>
                                <Form.Control type="number" name='waist_size' placeholder="Waist size" value={elem.waist_size || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                            </Col>
                        </Row>

                        <div className="p-t-15 bold">
                            Blood Pressure Readings :
                        </div>
                        {
                            elem.bp_reading && elem.bp_reading.map((el, ind) => (
                                <>
                                    <div className="p-t-4 font-size-xsm bold"> Reading {ind + 1} :</div>
                                    <Row className="p-t-4">
                                        <Col xs={4} md={4}>
                                            <span className="font-size-xsm">Systolic (mm Hg) <span className="red-color">*</span></span>
                                            <Form.Control type="number" name={'systolic ' + ind} placeholder='systolic' value={el.systolic || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                                        </Col>
                                        <Col xs={4} md={4}>
                                            <span className="font-size-xsm">Diastolic (mm Hg) <span className="red-color">*</span></span>
                                            <Form.Control type="number" name={'diastolic ' + ind} placeholder='diastolic' value={el.diastolic || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                                        </Col>
                                        <Col xs={4} md={4}>
                                            <span className="font-size-xsm">Pulse (mm Hg) <span className="red-color">*</span></span>
                                            <Form.Control type="number" name={'pulse ' + ind} placeholder='pulse' value={el.pulse || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                                        </Col>
                                    </Row>
                                </>
                            ))
                        }

                        <Row className="p-t-4">
                            <Col xs={12} md={12}>
                                <span className="font-size-xsm">Any weight change with in 12 months ? <span className="red-color">*</span></span>
                                <Form.Control as="select" name="is_there_weight_change" value={elem.is_there_weight_change || ''} onChange={(e) => this.handleChange(elem, index, e)}>
                                    <option value="">Any weight change with in 12 months ?</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </Form.Control>
                            </Col>
                        </Row>

                        {
                            elem.is_there_weight_change === "true" &&
                            <>
                                <Row className="p-t-4">
                                    <Col xs={12} md={12}>
                                        <span className="font-size-xsm">Weight Gained or Lost ? <span className="red-color">*</span></span>
                                        <Form.Control as="select" name="weight_change_type" value={elem.weight_change_type || ''} onChange={(e) => this.handleChange(elem, index, e)}>
                                            <option value="">Weight change ?</option>
                                            <option value="Gained">Gained</option>
                                            <option value="Lost">Lost</option>
                                        </Form.Control>
                                    </Col>
                                </Row>
                                <Row className="p-t-4">
                                    <Col xs={6} md={6}>
                                        <span className="font-size-xsm">Weight Changed by (in Kgs) ? <span className="red-color">*</span></span>
                                        <Form.Control type="number" name='weight_change_value' placeholder="Weight changed by" value={elem.weight_change_value || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                                    </Col>
                                    <Col xs={6} md={6}>
                                        <span className="font-size-xsm">Reason behind Weight Change ? <span className="red-color">*</span></span>
                                        <Form.Control type="text" name='reason_for_change' placeholder="Reason" value={elem.reason_for_change || ''} onChange={(e) => this.handleChange(elem, index, e)} />
                                    </Col>
                                </Row>
                            </>

                        }

                    </Form>

                )) : ''
            }
        </div>

        )
    }


    render() {
        return (
            <div className="order-details-dashboard">
                <div>
                    <TitleOrderHeader title="Collect Vitals" orderId={this.state.orderId} patientName={this.state.orderDetails ? this.state.orderDetails.pendingOrders[0].patientDetails[0].name : null}></TitleOrderHeader>
                </div>
               

                <div>
                    <Container>
                        {this.showForm()}
                    </Container>
                </div>
                <Container>
                    <Row>
                        <div className="fixed-bottom p-l-15 p-r-15 p-t-4 p-b-5">
                            <div className="display-flex justify-content-space-between p-b-10">
                                <div className="width-48">
                                    <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={() => this.goBackRoute()}>Back</button>
                                </div>
                                <div className="width-48">
                                    <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={() => this.redirectToBookLater()}> Clear</button>
                                </div>
                            </div>
                            
                            <div>
                                {this.state.showSnackbar && this.toastComponent()}
                            </div>
                            <div>
                                <Button type="submit" variant="primary" disabled={!this.state.submitBtnDisabled} size="lg" block className="border-curve-10" onClick={(e) => this.handleSubmit(e)}>
                                    Submit
                                </Button>
                            </div>

                        </div>
                    </Row>
                </Container>

            </div>
        )
    }
}
export default AddVitals;
